import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, Users, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";
import communityImage from "@/assets/women-community-support.jpg";

// Personality: Warm, human, hand-written feel — softer coral, rounded chat-bubble motif.
const CommunityLanding = () => {
  const quotes = [
    { q: "I thought I was losing my mind. Turns out I was just in perimenopause — and not alone.", n: "Rachel, 47" },
    { q: "The first place I've been able to say the quiet parts out loud.", n: "Danni, 51" },
    { q: "Someone answered my 3am question by 4am. That's the whole thing.", n: "Priya, 44" },
  ];
  return (
    <div className="min-h-screen bg-[hsl(15,60%,97%)]">
      <div className="container mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>

      <section className="container mx-auto px-6 pt-8 pb-16 text-center max-w-3xl">
        <span className="text-xs uppercase tracking-[0.3em] text-[hsl(15,70%,50%)]">The Community</span>
        <h1 className="mt-6 text-5xl md:text-7xl leading-[1.05]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          You're allowed to say <em className="italic">all</em> of it here.
        </h1>
        <p className="mt-8 text-lg text-foreground/70 leading-relaxed">
          A safe, anonymous circle of women in this same season of life. Ask the thing you can't ask
          anyone else. Read the reply that finally makes you feel seen.
        </p>
      </section>

      <section className="container mx-auto px-6 pb-20">
        <div className="rounded-[3rem] overflow-hidden aspect-[16/7] shadow-lifted">
          <img src={communityImage} alt="Community" className="w-full h-full object-cover" />
        </div>
      </section>

      {/* Chat-bubble testimonials */}
      <section className="container mx-auto px-6 pb-24 grid md:grid-cols-3 gap-6">
        {quotes.map((t, i) => (
          <div key={i} className={`relative bg-background rounded-[2rem] p-8 shadow-sm border border-[hsl(15,60%,90%)] ${i % 2 ? "md:mt-12" : ""}`}>
            <MessageCircle className="h-6 w-6 text-[hsl(15,70%,55%)] mb-4" />
            <p className="text-lg leading-relaxed mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>"{t.q}"</p>
            <p className="text-xs uppercase tracking-[0.25em] text-foreground/50">— {t.n}</p>
          </div>
        ))}
      </section>

      <section className="container mx-auto px-6 pb-24 text-center">
        <h2 className="text-3xl md:text-4xl mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Anonymous by default. Moderated by real humans.
        </h2>
        <Button asChild size="lg" className="px-10 py-6 text-lg bg-[hsl(15,70%,50%)] hover:bg-[hsl(15,70%,45%)]">
          <Link to="/community"><Users className="mr-2 h-5 w-5" /> Join the circle <ArrowRight className="ml-2 h-5 w-5" /></Link>
        </Button>
      </section>

      <Footer />
    </div>
  );
};
export default CommunityLanding;
